<template>
<div>
  <el-table :data="userList">
    <el-table-column width="160px" label="注册时间">
      <template slot-scope="scope">
        {{scope.row.createTime | moment}}
      </template>
    </el-table-column>
    <el-table-column width="100px" prop="__registerFrom" label="注册来源"></el-table-column>
    <el-table-column prop="id" label="账号ID"/>
<!--    <el-table-column prop="contractUserId" label="合约用户ID"/>-->
    <el-table-column prop="tel" label="手机号"/>
    <el-table-column prop="email" label="邮箱"/>
    <el-table-column prop="inviteCode" label="邀请码"/>
    <el-table-column prop="inviteCount" label="邀请用户数">
      <template slot-scope="scope">
        <a class="account-link" @click="getUserDetail(scope.row,scope.row.id)">{{ scope.row.inviteCount }}</a>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="用户状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__userStatus.color">
          {{scope.row.__userStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="120px" label="实名认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__idNoStatus.color">
          {{scope.row.__idNoStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="邮箱认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__emailSecurityStatus.color">
          {{scope.row.__emailSecurityStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="手机认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__phoneSecurityStatus.color">
          {{scope.row.__phoneSecurityStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="100px" label="Google认证">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__googleSecurityStatus.color">
          {{scope.row.__googleSecurityStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column width="120px" label="银行卡绑定状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__bankAuthStatus.color">
          {{scope.row.__bankAuthStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
<!--    <el-table-column width="100px" label="是否志愿者">-->
<!--      <template slot-scope="scope">-->
<!--        <el-tag :type="scope.row.__userVolunteerStatus.color">-->
<!--          {{scope.row.__userVolunteerStatus.text}}-->
<!--        </el-tag>-->
<!--      </template>-->
<!--    </el-table-column>-->
    <el-table-column width="100px" label="是否冻结">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__userBlockingStatus.color">
          {{scope.row.__userBlockingStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" width="200px">
      <template slot-scope="scope">
<!--        <el-button v-if="!scope.row.userVolunteerStatus" size="small" type="primary" @click="handleVolunteer(true, scope.row.id)">设为志愿者</el-button>-->
<!--        <el-button v-if="scope.row.userVolunteerStatus" size="small" type="primary" plain @click="handleVolunteer(false, scope.row.id)">取消志愿者</el-button>-->
         <el-button v-if="scope.row.userStatus === 0" size="small" type="danger" @click="handleBlocking(true, scope.row.id)">冻结</el-button>
        <el-button v-if="scope.row.userStatus === -1" size="small" type="danger" plain @click="handleBlocking(false, scope.row.id)">取消冻结</el-button>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="特殊操作" width="290px">
      <template slot-scope="scope">
        <el-button  size="small" type="danger" style="margin-bottom:12px"  @click="handleResetPassword(scope.row.id)">重置密码</el-button>
        <el-button  size="small" type="danger" style="margin-bottom:12px"  @click="handleResetGoogle(scope.row.id)">重置谷歌</el-button>
        <el-button  size="small" type="danger" style="margin-bottom:12px"  @click="handleUnlock(scope.row.id)">解锁登录</el-button>
        <!--限制交易不做 改为冻结-->
        <!-- <el-button  size="small" type="danger" style="margin-bottom:12px" @click="handleLimit(scope.row.id,false)">限制交易</el-button> -->
      </template>
    </el-table-column>
  </el-table>
  <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged"></pagination>


  <el-dialog title="邀请详情" :visible.sync="dialogVisibleShow" width="90%"
             :close-on-click-modal="false">

    <div>
      <div style="margin-top: 20px">
        <div style="float: left;width:200px">
             <span style="padding-right: 20px;">
            账户：</span>
          <sapn>{{showInfo.email}}</sapn>
        </div>
        <div style="float: left;width:300px;padding-left: 50px;">
           <span style="padding-right: 5px;">
            邀请总数：</span>
          <sapn>{{showInfo.inviteCount}}</sapn>
        </div>
        <div style="float: left;width:200px">
            <span style="padding-right: 20px;">
            邀请并升级VIP：</span>
          <span>{{showInfo.inviteVipCount}}</span>
        </div>
        <div >&nbsp;</div>
      </div>


      <div style="margin-top: 20px">
            <span style="padding-right: 20px;">
            邀请码：</span>
        <span>{{showInfo.inviteCode}}</span>
        &nbsp;&nbsp;&nbsp;
        <a class="account-link" @click="inviteDialog(showInfo.id,showInfo.inviteCode)">修改邀请码</a>
        <el-button  size="small" type="danger" style="float: right;"   @click="exportData(showInfo.id)">导出</el-button>
      </div>

      <div style="">&nbsp;</div>
      <div style="">&nbsp;</div>
      <div style="">&nbsp;</div>

    </div>
    <el-table :data="dataListUser" ref="multipleTable" >
      <el-table-column  label="序号">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column prop="email" label="账户"/>
      <el-table-column prop="address" label="钱包地址"/>
      <el-table-column prop="kycStatus" label="KYC状态">
        <template slot-scope="scope">
          {{ scope.row.kycStatus == false ? "未KYC" : "已KYC" }}
        </template>
      </el-table-column>
      <el-table-column prop="googleAuthStatus" label="google验证码">
        <template slot-scope="scope">
          {{ scope.row.googleAuthStatus == 0 || scope.row.googleAuthStatus ==null ? "未开通" : "已开通" }}
        </template>
      </el-table-column>
      <el-table-column prop="vipLevel" label="VIP等级"/>
      <el-table-column prop="createTime" label="注册时间">
      <template slot-scope="scope">{{ scope.row.createTime | moment }}</template>
      </el-table-column>
      <el-table-column prop="vipTime" label="开通VIP时间">
        <template slot-scope="scope">{{ scope.row.vipTime | moment }}</template>

      </el-table-column>

    </el-table>
  </el-dialog>


  <el-dialog title="修改邀请码" :visible.sync="dialogCodeVisibleEdit" append-to-body=true width="40%" height="30%"
             :close-on-click-modal="false">
    <div>
      <div style="margin-top: 20px">
          <span style="padding-right: 20px">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            新邀请码</span>
        <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength =8
                  v-model="inviteCode">
          &nbsp;
        </el-input>
        <div style="margin-top: 20px">
          <span><i style="color: #f56c6c;margin-right: 1px;">邀请码位数为8位数字+字母组成，不可有数字1,0，字母L,I,O</i></span>
        </div>

      </div>
    </div>
    <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="modifyInviteCode">确 定</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </span>
  </el-dialog>

</div>


</template>


<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Pagination from 'components/pagination';
import api from '../../api'
export default {
  name: 'UserList',
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('user', ['userList']),
    ...mapState('user', ['pagination', 'totalCount'])
  },
  data() {
    return {
      account: '',
      dataList: [],
      userId:'',
      inviteCode:'',
      dialogVisible: false,
      dialogCodeVisibleEdit: false,
      dialogVisibleShow: false,
      dataListUser:[],
      showInfo: {},
      taskData: {},
      total:0,
      queryCondition:{
        pageNo:1
      },
      queryData: {
        search: '',
        page: 1,
        size: 100
      },
      queryData2: {
        pageNum: 1,
        pageSize: 10,
        queryValue: "",
        queryType: "",
        groupId: "",
        groupType: ""
      },
      saveData: {
        name: "",
        email: "",
        notes: ""
      },
      editData: {
        id: 0,
        name: "",
        email: "",
        notes: ""
      }
    }
  },
  methods: {
    ...mapActions('user', ['updateVolunteer', 'updateBlocking','resetPassword','resetGoogle','cleanLoginForbid','getUserDetail']),
    pageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
    handleBlocking(isSet, id) {
      const message = isSet ? '确认将此用户冻结吗？' : '确认取消冻结吗？';
      this.$confirm(message, '提示', {
        type: 'warning'
      }).then(() => {
        this.updateBlocking({
          id,
          status: isSet ? -1 : 0
        }).then(() => {
          this.$message.success('设置成功！');
          this.$emit('refresh');
        });
      });
    },
    closeDialog() {
      this.dialogCodeVisibleEdit = false;
      this.inviteCode = "";
    },
    handleResetPassword(id) {
      const message = "确认重置此用户密码吗？";
      this.$confirm(message,'提示',{
        type: 'warning'
      }).then(()=>{
        this.resetPassword({
          id
        }).then(()=>{
          this.$message.success('设置成功！');
          this.$emit('refresh');
        })
      })
    },
    handleResetGoogle(id) {
      const message = "确认重置此用户谷歌验证吗？";
      this.$confirm(message,'提示',{
        type: 'warning'
      }).then(()=>{
        this.resetGoogle({
          id
        }).then(()=>{
          this.$message.success('设置成功！');
          this.$emit('refresh');
        })
      })
    },
    inviteDialog(userid,inviteCode){
      this.dialogCodeVisibleEdit = true
      this.userId = userid;
      this.inviteCode = inviteCode
    },
      exportData(userId){
          api.export({
              userId
          }).then(response => {
              const fileName = "邀请详情" + this.userId+ ".xlsx";
              const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
              if ('download' in document.createElement('a')) {
                  const link = document.createElement('a');
                  link.download = fileName;
                  link.style.display = 'none';
                  link.href = URL.createObjectURL(blob);
                  document.body.appendChild(link);
                  link.click();
                  URL.revokeObjectURL(link.href);
              } else {
                  navigator.msSaveBlob(blob, fileName);
              }
          })
      },
    modifyInviteCode(){
      let userId1 = this.userId;
      let inviteCode1 = this.inviteCode
      inviteCode1 = inviteCode1.toUpperCase();
      //L,i,O
      if(inviteCode1.includes("1") || inviteCode1.includes("0")
              || inviteCode1.includes("L")  ||inviteCode1.includes("I") ||inviteCode1.includes("O") || inviteCode1.length !=8){
        this.$message.error('请按格式填写邀请码！');
        return;
      }
      api.updateInviteCode({
        userId1,inviteCode1
      }).then(res => {
        this.showInfo.inviteCode = inviteCode1
        this.dialogCodeVisibleEdit = false;
        this.$emit('refresh');
      })
    },
    getUserDetail(rowdata,userId) {
      this.showInfo = rowdata;
      api.getUserDetail1({
        userId
      }).then(res => {
        this.dialogVisibleShow = true;
        this.dataListUser = res.data;
      })
      this.detailDialogVisible = true;
    },
    handleUnlock(id) {
      const message = "确认解锁登录！";
      this.$confirm(message,'提示',{
        type: 'warning'
      }).then(()=>{
        this.cleanLoginForbid({
          id
        }).then(()=>{
          this.$message.success('设置成功！');
          this.$emit('refresh');
        })
      })
    },
    handleLimit(id,isSet) {
      const message = isSet
        ? '限制交易后此用户将无法执行所有交易行为，是否确认限制？'
        : '确认解除对此用户的交易限制吗？';
      this.$confirm(message, '限制交易', {
        type: 'warning'
      }).then(() => {
        this.updateVolunteer({
          id,
          status: isSet ? 1 : 0
        }).then(() => {
          this.$message.success('设置成功！');
          this.$emit('refresh');
        });
      });
    },
    handleVolunteer(isSet, id) {
      const message = isSet
        ? '确认将此用户设为志愿者吗？'
        : '确认取消此志愿者吗？';
      this.$confirm(message, '提示', {
        type: 'warning'
      }).then(() => {
        this.updateVolunteer({
          id,
          status: isSet ? 1 : 0
        }).then(() => {
          this.$message.success('设置成功！');
          this.$emit('refresh');
        });
      });
    }
  },


};
</script>

<style lang="less" scoped>
  @import url("~styles/variables.less");

  .account-link,
  .network-link {
    color: @color-primary;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
